export default __webpack_public_path__ + "static/media/logo-vedi-blanco.7028030d.svg";